import axios from "axios";

const ConnectionsClient = axios.create({
	baseURL: "https://api.applaby.com", //"https://dev.applaby.com:8010/iframe", // You can replace this with your actual base URL
	timeout: 10000, // You can set a timeout if needed
	headers: {
		"Content-Type": "application/json",
		// You can add any custom headers here, like an auth token if necessary
	},
	withCredentials: true,
});

// Optionally, add an interceptor to handle common request or response logic
ConnectionsClient.interceptors.request.use(
	(config) => {
		// Modify the request configuration if necessary (e.g., add auth token)
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

ConnectionsClient.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		// Handle any error globally
		if (
			error.status === 401 &&
			error.response.data?.message === "INVALID_TOKEN"
		) {
			const hasReloaded = sessionStorage.getItem("iframeHasReloaded");

			if (!hasReloaded) {
				sessionStorage.setItem("iframeHasReloaded", "true");
				window.location.reload();
			}
		}
		return Promise.reject(error);
	}
);

export default ConnectionsClient;
